import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNavigateTransition } from '../lib/navigation';
import { isMidFlow, isQuizHalf } from '../lib/routes';
import { useFlow } from '../state/flow';
import { QUIZ_COPY } from '../lib/quizCopy';
import ConfirmDialog from './ConfirmDialog';
import './Header.scss';

export default function Header() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigateTransition();
  const { idFormTouched } = useFlow();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const onQuizHalf = isQuizHalf(pathname);
  const target = onQuizHalf ? '/id-card' : '/class';
  const switchLabel = onQuizHalf ? QUIZ_COPY.getYourIdCard : QUIZ_COPY.getToClass;

  // Confirm only when leaving mid-progress (not on an end screen). A pristine
  // ID-card form (nothing edited this visit) is exempt.
  const needsConfirm = isMidFlow(pathname) && (pathname !== '/id-card' || idFormTouched);

  function go() {
    navigate(target);
  }

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <img src="/img/logo.svg" alt={t('header.briarUniversity')} className="site-header__logo" />
        <button
          type="button"
          className="site-header__switch"
          onClick={() => (needsConfirm ? setConfirmOpen(true) : go())}
        >
          {switchLabel}
        </button>
      </div>

      <ConfirmDialog
        open={confirmOpen}
        title={QUIZ_COPY.switchTitle}
        body={QUIZ_COPY.switchBody}
        confirmLabel={QUIZ_COPY.confirmYes}
        cancelLabel={QUIZ_COPY.confirmNo}
        onConfirm={() => {
          setConfirmOpen(false);
          go();
        }}
        onCancel={() => setConfirmOpen(false)}
      />
    </header>
  );
}
